import {Component, EventEmitter, Inject, Input, Output, ViewChild} from '@angular/core';
import {RestrictedIata} from "../../shared/models/restricted-iata";
import {SpinnerComponent as Spinner} from '@westjetairlines/wjesd-component-library';
import {Partner} from "../../shared/models/partner";
import {IATA_SERVICE_TOKEN} from "../../shared/services/iata.service";
import {TRAVEL_CREDIT_SERVICE_TOKEN} from "../../shared/services/travel-credit.service";
import {NgModel} from "@angular/forms";

@Component({
  selector: 'app-manage-dialog',
  templateUrl: './manage-dialog.component.html',
  styleUrls: ['./manage-dialog.component.css']
})
export class ManageDialogComponent{
  showSuccess: boolean = false;
  showError: boolean = false;
  message: string = '';
  @Output() dialogClosed = new EventEmitter();
  @Input() title: string;
  @Input() id: string;
  @Input() restrictedIata: RestrictedIata;
  partners: Array<Partner> = new Array<Partner>();
  selectedPartnerId = 0;
  @ViewChild(NgModel) iataNumberControl: NgModel;

  constructor(@Inject(IATA_SERVICE_TOKEN) private iataService, @Inject(TRAVEL_CREDIT_SERVICE_TOKEN) private travelCreditService){
  }

  ngOnChanges(input){
    this.selectedPartnerId = this.restrictedIata ? (this.restrictedIata.iataPartner ? (this.restrictedIata.iataPartner.id ? this.restrictedIata.iataPartner.id : 0) : 0): 0;
    this.travelCreditService.getPartners().subscribe(data => {
      this.partners = data;
    },
    err => {
      console.log('error', err);
      Spinner.stop();
    },
    () => {
      Spinner.stop();
    });
    this.setTitle();
  }

  setTitle(){
    let action = this.isEditMode() ? "Edit a" : "Add a new";
    this.title = action + " restricted IATA";
  }

  isEditMode(){
    return +this.restrictedIata.id > 0;
  }

  onCancel(){
    this.showSuccess = false;
    this.showError = false;
    this.dialogClosed.emit();
  }

  onSave(){
    Spinner.start();
    this.restrictedIata.iataPartner = this.partners.find(t => +t.id === +this.selectedPartnerId);
    if (this.isEditMode()) {
      this.iataService.editRestrictedIata(this.restrictedIata).subscribe(result => {
        if (result.wasSuccessful) {
          this.showError = false;
          this.showSuccess = true;
          this.message = 'Your changes have been saved for IATA number ' + result.value.iataNumber + ".";
        }
        else {
          this.showSuccess = false;
          this.showError = true;
          this.message = result.brokenRules[0].message;
        }
      },
      err => {
        console.log('error', err);
        Spinner.stop();
      },
      () => {
        Spinner.stop();
      });
    }
    else{
      this.iataService.addRestrictedIata(this.restrictedIata).subscribe(result => {
        if (result.wasSuccessful) {
          this.showError = false;
          this.showSuccess = true;
          this.message = 'The IATA number '+result.value.iataNumber+' has been saved.';
          this.restrictedIata = new RestrictedIata();
          this.iataNumberControl.control.reset();
        }
        else {
          this.showSuccess = false;
          this.showError = true;
          this.message = result.brokenRules[0].message;
        }
      },
      err => {
        console.log('error', err);
        Spinner.stop();
      },
      () => {
        Spinner.stop();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-iata/manage-dialog/manage-dialog.component.ts